import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { SesionService } from '../core/sesion.service';

@Component({
  selector: 'app-acceso',
  standalone: true,
  imports: [FormsModule],
  template: `
    <div class="acceso-lienzo">
      <div class="acceso-panel">
        <div class="acceso-marca">N E X A M E D   C R M</div>
        <div class="acceso-lema">Cada paciente,<br>en su lugar.</div>
        <div class="acceso-pie">© 2026 NexaMed CRM · Centro Oftalmológico Ebenezer</div>
      </div>

      <div class="acceso-area">
        <form class="acceso-form" (ngSubmit)="ingresar()">
          <div class="acceso-titulo">Iniciar sesión</div>

          <div class="acceso-campo">
            <label class="m" for="correo">Usuario</label>
            <input
              id="correo"
              name="correo"
              type="email"
              class="acceso-input"
              autocomplete="username"
              [(ngModel)]="correo"
              [disabled]="cargando()"
              required
            />
          </div>

          <div class="acceso-campo">
            <label class="m" for="clave">Contraseña</label>
            <input
              id="clave"
              name="clave"
              type="password"
              class="acceso-input"
              autocomplete="current-password"
              [(ngModel)]="clave"
              [disabled]="cargando()"
              required
            />
          </div>

          @if (error()) {
            <div class="acceso-error" role="alert">{{ error() }}</div>
          }

          <button type="submit" class="acceso-boton" [disabled]="cargando()">
            {{ cargando() ? 'Ingresando...' : 'Ingresar' }}
          </button>
        </form>
      </div>
    </div>
  `,
  styles: [`
    .acceso-lienzo {
      display: flex;
      gap: 18px;
      padding: 18px;
      min-height: 100vh;
      background: var(--ground);
    }

    .acceso-panel {
      width: 520px;
      max-width: 48%;
      background: #0E2A4F;
      color: #FFFFFF;
      border-radius: 18px;
      padding: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .acceso-marca {
      font-weight: 700;
      letter-spacing: .5em;
      font-size: 14px;
    }

    .acceso-lema {
      font-size: 34px;
      font-weight: 700;
      line-height: 1.12;
    }

    .acceso-pie {
      font-size: 11px;
      color: #8FA2BD;
    }

    .acceso-area {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }

    .acceso-form {
      width: 300px;
      display: flex;
      flex-direction: column;
      gap: 14px;
    }

    .acceso-titulo {
      font-size: 22px;
      font-weight: 700;
      color: #0E2A4F;
    }

    .acceso-campo {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .acceso-input {
      height: 38px;
      border: 1px solid #E3E8EF;
      border-radius: 10px;
      background: #FFFFFF;
      padding: 0 12px;
      font: 500 13px var(--font);
      color: #0E2A4F;
      outline: none;
    }

    .acceso-input:focus {
      border-color: #035CB1;
      box-shadow: 0 0 0 3px rgba(3, 92, 177, .12);
    }

    .acceso-error {
      font-size: 12px;
      font-weight: 500;
      color: var(--red);
      background: var(--red-soft);
      padding: 8px 12px;
      border-radius: 8px;
    }

    .acceso-boton {
      height: 40px;
      border-radius: 10px;
      background: #035CB1;
      border: 1px solid #035CB1;
      color: #FFFFFF;
      font: 600 13px var(--font);
      cursor: pointer;
    }

    .acceso-boton:disabled {
      opacity: .65;
      cursor: not-allowed;
    }

    @media (max-width: 820px) {
      .acceso-lienzo {
        flex-direction: column;
      }
      .acceso-panel {
        width: 100%;
        max-width: 100%;
        min-height: 220px;
      }
    }
  `]
})
export class AccesoComponent {
  private readonly sesion = inject(SesionService);
  private readonly router = inject(Router);

  correo = '';
  clave = '';
  readonly cargando = signal(false);
  readonly error = signal<string | null>(null);

  ingresar() {
    this.error.set(null);
    if (!this.correo.trim() || !this.clave) {
      this.error.set('Correo y contraseña son obligatorios.');
      return;
    }

    this.cargando.set(true);
    this.sesion.iniciarSesion(this.correo.trim(), this.clave).subscribe({
      next: () => {
        this.cargando.set(false);
        this.router.navigateByUrl('/pendientes');
      },
      error: (err: HttpErrorResponse) => {
        this.cargando.set(false);
        const mensaje = err.error?.error ?? 'No fue posible iniciar sesión.';
        this.error.set(mensaje);
      }
    });
  }
}
